import { IS_USE_PLEX_API } from '../../../constants';
import { CasinoTypeUnion } from '../../../types';
import { useGamesStore } from '../../store';

export const useGetIsLobbyDataLoaded = (
  feedName: string,
  casinoType: CasinoTypeUnion
) => {
  // providers request in plex takes more time, so ignore it in lobbyDataLoaded
  // we will check isProvidersLoaded separately only in places where we really need providers-data to be loaded
  return useGamesStore((store) =>
    IS_USE_PLEX_API
      ? store.lobbies[casinoType]?.isCategoriesLoaded
      : store.feeds[feedName]?.isLoaded
  );
};
